import { View } from "react-native";

import { BrandLoader } from "@/ui/BrandLoader";

import { ProductHeader } from "./header/ProductHeader";
import { useScreenStyles } from "./screenStyles";

/** Neutral loading screen while the session restores: product header, no content (FR-012). */
export function LoadingScreen() {
  const styles = useScreenStyles();
  return (
    <View style={styles.screen} testID="loading-screen">
      <ProductHeader />
      <View style={styles.body} role="main">
        <BrandLoader width={200} />
      </View>
    </View>
  );
}
